import Select from "@components/core/Select";
import { ArgumentTypeSelectorProps } from "@customTypes/components/selectors/ArgumentTypeSelector";

import { ArgumentType, beadlSelector } from "@store/beadl";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { itemIdentifier, renderLabel } from "../util";

const ArgumentTypeSelector = (props: ArgumentTypeSelectorProps) => {
  const {
    selected,
    onChange,
    placeholder = "Select argument type",
    options,
    className,
    allowClear,
    onClear,
  } = props;

  const { argumentTypes: { data: argumentTypes } } = useSelector(beadlSelector);

  const handleChange = useCallback(
    (id: number, item?: ArgumentType) => {
      onChange && onChange(id, item);
    },
    [onChange]
  );

  return (
    <Select
      allowClear={allowClear}
      onClear={onClear}
      className={className}
      options={options || argumentTypes}
      selected={selected}
      onChange={handleChange}
      placeholder={placeholder}
      labelRender={(item) => renderLabel(item, "name")}
      itemIdentifier={(item) => itemIdentifier(item, "id")}
    />
  );
};

export default ArgumentTypeSelector;
